module.exports = __webpack_public_path__ + "img/join_logo2x.d0a87146.png";